import ClinicalConcerns from './ClinicalConcerns';

export default ClinicalConcerns;
